<ng-template #template>
    <div *ngIf="isOnTrial; else subscriptionExpiring" style="width: auto; height: auto; font-size: 20px; ">
      <a  style="text-align: center;">Time is running out! Your 30-day trial expires in
      <span class="text-red">{{ license.daysLeft }} day(s)</span></a>
    </div>
   
    <ng-template #subscriptionExpiring>
      <div *ngIf="license.daysLeft >= -7; else trialExpired">
        Last chance to keep the perks rolling! Renew your subscription in
        <span class="text-red">{{ license.daysLeft > 0 ? license.daysLeft : (license.daysLeft * -1) }} day(s)</span>
      </div>
    </ng-template>
   
    <ng-template #trialExpired>
      <div>
        Uh-oh! Your free trial ended
        <span class="text-red">{{ (license.daysLeft * -1) % 30 }} day(s) ago</span>😟
      </div>
    </ng-template>
   
    <div style="margin-left: 30px;">
      <button type="button" (click)="navigateToPlan()" class="btn">Resubscribe</button>
    </div>
   </ng-template>